export default "__VITE_ASSET__DgdNJGYR__"